<script setup>
import ToolboxItemPill from './ToolboxItemPill.vue';
import { setDraggingItem, clearDraggingItem } from './toolboxDrag';

/**
 * ToolboxItem - A reusable component for displaying tools and attributes in the toolbox
 * Supports drag and drop functionality with visual feedback
 * Automatically styles based on item type (tool/attribute)
 */
defineProps({
  item: {
    type: Object,
    required: true,
    // Expected structure: { id, name, label?, icon?, itemType: 'tool'|'attribute', isMainTool: boolean, ... }
  },
  label: {
    type: String,
    required: false,
    default: null,
  },
});

function handleDragStart(event, item) {
  const dragData = {
    type: 'item',
    item,
  };

  event.dataTransfer.setData('application/json', JSON.stringify(dragData));
  event.dataTransfer.effectAllowed = 'copy';
  setDraggingItem(item);

  event.target.style.opacity = '0.5';
}

function handleDragEnd(event) {
  event.target.style.opacity = '1';
  clearDraggingItem();
}
</script>

<template>
  <div
    class="w-fit min-w-[120px] max-w-full cursor-grab active:cursor-grabbing"
    draggable="true"
    @dragstart="handleDragStart($event, item)"
    @dragend="handleDragEnd($event)"
  >
    <ToolboxItemPill
      :item="item"
      :label="label"
      :is-main-tool="item.isMainTool !== false"
      trailing-icon="i-lucide-grip"
    />
  </div>
</template>
